/**
 * Commande secrète ouvrant l'écran d'administration COM+ : saisir la séquence au clavier,
 * hors d'un champ de saisie. Elle n'ouvre rien tant que l'API refuse l'accès
 * (site client : réglage « accès client » désactivé depuis la version vendeur).
 */
export const COMPLUS_ADMIN_SECRET_SEQUENCE = 'complus';

const SEQUENCE_TIMEOUT_MS = 3000;

export class ComPlusAdminSecretCommand {
  private buffer = '';
  private lastKeyTime = 0;

  /** @returns `true` quand la séquence vient d'être complétée. */
  public handle(event: KeyboardEvent): boolean {
    if (event.ctrlKey || event.metaKey || event.altKey || event.key?.length !== 1 || this.isEditable(event.target)) {
      return false;
    }

    const now = Date.now();
    if (now - this.lastKeyTime > SEQUENCE_TIMEOUT_MS) {
      this.buffer = '';
    }
    this.lastKeyTime = now;

    this.buffer = (this.buffer + event.key.toLowerCase()).slice(-COMPLUS_ADMIN_SECRET_SEQUENCE.length);
    if (this.buffer === COMPLUS_ADMIN_SECRET_SEQUENCE) {
      this.buffer = '';
      return true;
    }

    return false;
  }

  private isEditable(target: EventTarget | null): boolean {
    const element = target as HTMLElement | null;
    if (!element) {
      return false;
    }
    return element.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(element.tagName);
  }
}
